// extracted by mini-css-extract-plugin
export var infoRow = "_uu-2";
export var labelContainer = "_uu-0";
export var rightInfo = "_uu-1";